/**
 * Labstep
 *
 * @module prosemirror/components/Toolbar/Main
 * @desc Main toolbar displayed at the top of the editor
 */

import debounceRender from 'labstep-web/containers/DebounceRender';
import { AlignmentToolbar as ToolbarAlignment } from 'labstep-web/prosemirror/components/Toolbar/Alignment';
import { Break } from 'labstep-web/prosemirror/components/Toolbar/Break';
import { ClearFormattingToolbar as ToolbarClearFormatting } from 'labstep-web/prosemirror/components/Toolbar/ClearFormatting';
import { ColorPickerToolbar as ToolbarColorPicker } from 'labstep-web/prosemirror/components/Toolbar/ColorPicker';
import { HeadingToolbar as ToolbarHeading } from 'labstep-web/prosemirror/components/Toolbar/Heading';
import { ExtensionHistoryToolbar as ToolbarHistory } from 'labstep-web/prosemirror/components/Toolbar/History';
import { ToolbarInline } from 'labstep-web/prosemirror/components/Toolbar/Inline';
import { ListToolbar as ToolbarList } from 'labstep-web/prosemirror/components/Toolbar/List';
import { MarkToolbar as ToolbarMark } from 'labstep-web/prosemirror/components/Toolbar/Mark';
import { SymbolToolbar as ToolbarSymbol } from 'labstep-web/prosemirror/components/Toolbar/Symbol';
import { TableToolbar as ToolbarTable } from 'labstep-web/prosemirror/components/Toolbar/Table';
import type React from 'react';
import { isMobile } from 'react-device-detect';
import styles from './styles.module.scss';
import type { IToolbarMainProps } from './types';

export const ToolbarMain: React.FC<IToolbarMainProps> = ({
  view,
  entity,
  experimentWorkflow,
}) => {
  const { state, dispatch } = view;

  return (
    <div className={styles.container}>
      {isMobile && (
        <>
          <ToolbarInline
            view={view}
            entity={entity}
            experimentWorkflow={experimentWorkflow}
          />
          <Break />
        </>
      )}
      <ToolbarHistory state={state} dispatch={dispatch} />
      <Break />
      <ToolbarSymbol state={state} dispatch={dispatch} />
      <Break />
      <ToolbarHeading state={state} dispatch={dispatch} />
      <ToolbarMark state={state} dispatch={dispatch} />
      <Break />
      <ToolbarColorPicker view={view} />
      <Break />
      <ToolbarAlignment state={state} dispatch={dispatch} />
      <Break />
      <ToolbarList state={state} dispatch={dispatch} />
      <Break />
      <ToolbarClearFormatting state={state} dispatch={dispatch} />
      <ToolbarTable state={state} dispatch={dispatch} />
    </div>
  );
};

export default debounceRender(ToolbarMain as any);
